import React, {Component} from 'react';
import classnames from 'classnames';
import {Waypoint} from '@homeaway/react-unveil';
import Modal from './Modal';
import './ScrollingBodyModal.less';

class ScrollingBodyModal extends Component {
    static propTypes = {...Modal.propTypes};
    static defaultProps = {...Modal.defaultProps};

    state = {
        topWaypointShown: true,
        bottomWaypointShown: false
    };

    onTopWaypointEnter = () => this.setState({topWaypointShown: true});
    onTopWaypointLeave = () => this.setState({topWaypointShown: false});
    onBottomWaypointEnter = () => this.setState({bottomWaypointShown: true});
    onBottomWaypointLeave = () => this.setState({bottomWaypointShown: false});

    render() {
        const {topWaypointShown, bottomWaypointShown} = this.state;
        const {className, children, ...rest} = this.props;

        const classNames = classnames('ScrollingBodyModal', className, {
            'ScrollingBodyModal--scroll-shadow-top': !topWaypointShown,
            'ScrollingBodyModal--scroll-shadow-bottom': !bottomWaypointShown,
            'ScrollingBodyModal--no-footer': !this.props.footer
        });

        return (
            <Modal {...rest} className={classNames}>
                <Waypoint
                    onEnter={this.onTopWaypointEnter}
                    onLeave={this.onTopWaypointLeave}
                />
                {children}
                <Waypoint
                    onEnter={this.onBottomWaypointEnter}
                    onLeave={this.onBottomWaypointLeave}
                />
            </Modal>
        );
    }
}

export default ScrollingBodyModal;
